﻿global.Inputmask = require('Tango/jquery/inputmask.js');
require('Tango/jquery/inputmask.extensions.js');
require('Tango/jquery/inputmask.numeric.extensions.js');
global.Vue = require('Root/vue.min.js');
global.d3 = require('d3');
global.katex = require('katex');
global.canvg = require('canvg');
require('Tango/tango/katexproxy.js');
global.signalR = require('Root/signalr.min.js');

require('Root/calendarstatusresolver.js');
require('Root/messageresolver.js');
